import React, { useEffect, useState } from "react";
import { Empty, Spin } from "antd";
import { apiCall } from "../utils/Api";
import Title from "./Title";
import TitleExtras from "./TitleExtras";
import Pubstock from "./Pubstock";

export default function PreviousRender(props){

    const {eisbn} = props;
    const [loading, setLoading] = useState(true);
    const [previous, setPrevious] = useState("")
    const [data, setData] = useState(false);
 
    const getPreviousEdition = () => {

        apiCall("title/getRelatedEditionsDetails", {eisbn : eisbn, detail_category: "previous_edition"}, (_status, _result) => {
            if(_result.rows[0]){
                setPrevious(_result.rows[0].eisbn);
                setData(_result.rows[0]);
            }
            setLoading(false);
        })
    }

    useEffect(getPreviousEdition, []);

    return(<>
        <Spin spinning={loading} >
        {(previous && 
            <div key={previous} className="summary-link">
                <Title data={data} load_id={previous}/>
                <div style={{ "maxWidth": "570px" }}>
                    <TitleExtras titlelist_id={data.titlelist_id} view={"calendar"} data={data} />
                    <Pubstock eisbn={data.eisbn} suppliers={data.pubstock} />
                </div>
            </div>)}
        {(!previous && <div style={{"height" : "200px", "display" : "flex", "flexDirection" : "column-reverse"}}><Empty description="No previous edition found." image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>)}
        </Spin></>)
}